import { createMuiTheme } from '@material-ui/core/styles';
import blueGrey from '@material-ui/core/colors/blueGrey';
import blue from '@material-ui/core/colors/blue';

const lightThemeTextColor = '#000000';
const darkThemeTextColor = '#ffffff';

export const lightTheme = createMuiTheme({
    palette: {
        type: 'light',
        primary: blueGrey,
        secondary: blue,
    },
    typography: {
        useNextVariants: true,
        h1: { color: lightThemeTextColor },
        h2: { color: lightThemeTextColor },
        h3: { color: lightThemeTextColor },
        h4: { color: lightThemeTextColor },
        h5: { color: lightThemeTextColor },
        h6: { color: lightThemeTextColor },
        subtitle1: { color: lightThemeTextColor },
        subtitle2: { color: lightThemeTextColor },
        body1: { color: lightThemeTextColor },
        body2: { color: lightThemeTextColor },
        button: { color: lightThemeTextColor },
        caption: { color: lightThemeTextColor },
        overline: { color: lightThemeTextColor }
    }
});

export const darkTheme = createMuiTheme({
    palette: {
        type: 'dark',
        primary: blueGrey,
        secondary: blue,
    },
    typography: {
        useNextVariants: true,
        h1: { color: darkThemeTextColor },
        h2: { color: darkThemeTextColor },
        h3: { color: darkThemeTextColor },
        h4: { color: darkThemeTextColor },
        h5: { color: darkThemeTextColor },
        h6: { color: darkThemeTextColor },
        subtitle1: { color: darkThemeTextColor },
        subtitle2: { color: darkThemeTextColor },
        body1: { color: darkThemeTextColor },
        body2: { color: darkThemeTextColor },
        button: { color: darkThemeTextColor },
        caption: { color: darkThemeTextColor },
        overline: { color: darkThemeTextColor }
    }
});